type ScrollTarget = 'top' | 'bottom'

/**
 * Scrolls the nearest scrollable ancestor of `node` (or the window) to its top
 * or bottom. `bottom` is for when new items land at the end of the list
 * (oldest-first sort). Honors `prefers-reduced-motion`.
 */
export const scrollNearestScrollable = (
  node: HTMLElement | null,
  to: ScrollTarget = 'top',
): void => {
  if (!node) return

  let scrollableParent = node.parentElement
  while (scrollableParent) {
    const { overflow, overflowY } = window.getComputedStyle(scrollableParent)
    if (
      overflow === 'auto' ||
      overflow === 'scroll' ||
      overflowY === 'auto' ||
      overflowY === 'scroll'
    ) {
      break
    }
    scrollableParent = scrollableParent.parentElement
  }

  const prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const behavior: ScrollBehavior = prefersReducedMotion ? 'auto' : 'smooth'

  if (to === 'bottom') {
    const bottom = scrollableParent
      ? scrollableParent.scrollHeight
      : document.documentElement.scrollHeight
    ;(scrollableParent || window).scrollTo({ top: bottom, behavior })
    return
  }

  ;(scrollableParent || window).scrollTo({ top: 0, behavior })
}
